import dynamicFilter from './filters/dynamicFilter.filter';
import TransferOrderComponent from './components/transportauftrag.component';
import TransferOrderListComponent from './components/transferorder.list.component';
import TransferOrderCreateComponent from './components/transferorder.create.component';
import TransferOrderService from './services/transferOrder.service';
import TimeService from './services/time.service';
import TransferOrderStateService from './services/transferOrderState.service';
import LocationService from './services/location.service';
import OrderService from './services/order.service';
import UnitService from './services/unit.service';
import DaisyValidationService from "./services/daisyValidation.service";
import ArtikelUmbuchenComponent from "./components/artikelUmbuchen.component";

angular
	.module('app.transportauftrag', [
		'md.data.table',
		'ngStorage'
	])
	.filter('dynamicFilter', dynamicFilter)
	.service('LocationService', LocationService)
	.service('OrderService', OrderService)
	.service('TransferOrderService', TransferOrderService)
	.service('TransferOrderStateService', TransferOrderStateService)
	.service('TimeService', TimeService)
	.service('UnitService', UnitService)
	.service('DaisyValidationService', DaisyValidationService)
	.component('transportauftrag', TransferOrderComponent)
	.component('transportauftragList', TransferOrderListComponent)
	.component('transportauftragCreate', TransferOrderCreateComponent)
	.component('artikelUmbuchen', ArtikelUmbuchenComponent);
